const sizeMappings = {
    small: 12,
    medium: 16,
    large: 20,
};
function getIconSize(size) {
    const resolvedSize = typeof size === 'string' ? sizeMappings[size] : size;
    const iconWidth = `${resolvedSize / 10}rem`;
    const iconHeight = `${resolvedSize / 10}rem`;
    return { iconWidth, iconHeight };
}
export default getIconSize;
//# sourceMappingURL=get-icon-size.js.map